<template>
    <div class="grid--con">
        <div class="mgr10 mgl10">
            <!-- 목록 -->
            <template v-if="qstnSe == 'list'">
                <div class="board-number-cases">전체 <span>{{paginginfo.totCnt}}</span>건</div>
                <div class="board-list mgt10">
                    <ul>
                        <template v-if="qstnList.length > 0">
                            <li v-for="qstnInfo in qstnList"
                                :key="'qstn' + qstnInfo.sn"
                                @click="detailQstnInfo(qstnInfo.sn)">
                                <a href="javascript:;">
                                    <div class="board-tit-con">
                                        <div class="entry-tag">
                                            <span :class="qstnInfo.sttusClas+' inquiry'">{{qstnInfo.sttusNm}}</span>
                                        </div>
                                        <div class="entry-title"><span>[{{qstnInfo.clCdNm}}]</span> {{qstnInfo.sj}}</div>
                                        <div class="entry-date">{{qstnInfo.qstnDt.substr(0, 10)}}</div>
                                    </div>
                                </a>
                            </li>
                        </template>
                        <li v-if="qstnList.length == 0">
                            <a href="javascript:;">
                                <div class="board-tit-con">
                                    <div class="entry-title">1:1문의내역이 없습니다. 문의하기 버튼을 눌러 문의해주세요.</div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <pagenavi :paginginfo="paginginfo" v-if="paginginfo.totCnt > paginginfo.pageListCnt"></pagenavi>
                <div class="btn-wrap f-oh __right mgt30 mgb20">
                    <div class="f-left">
                        <button class="middle _bt-blue" @click="startRmtAstnc()">원격지원 시작하기</button>
                        <button class="middle" @click="clickRmtAstnc()"><div class="img-com _bt-ic04"><span>원격지원 아이콘</span></div>원격지원이 뭔가요?</button>
                    </div>
                    <button class="middle _bt-navy" @click="qstnSe = 'write'">문의하기<div class="img-com _bt-ic05"><span>문의하기 아이콘</span></div></button>
                </div>
            </template>
            <!-- //목록 -->
            <!-- 상세보기 -->
            <template v-if="qstnSe == 'view'">
                <div class="board-view box-type01">
                    <div class="section-title">
                        <div class="board-tit-con">
                            <div class="entry-tag inquiry">
                                <span :class="qstnDetailInfo.sttusClas">{{qstnDetailInfo.sttusNm}}</span>
                            </div>
                            <div class="entry-title"><span>[{{qstnDetailInfo.clCdNm}}]</span> {{qstnDetailInfo.sj}}</div>
                            <div class="entry-date">{{qstnDetailInfo.qstnDt.substr(0, 10)}}</div>
                        </div>
                    </div>
                    <div class="section-file" v-if="qstnFileList.length > 0">
                        <div class="file-att-list">
                            <ul>
                                <li v-for="(fileInfo, index) in qstnFileList"
                                    :key="'qstnFileInfo' + index">
                                    <a href="javascript:;" @click="downloadFile(fileInfo)">
                                        <div class="img-com" :class="$onbiLib.bindFileIconClass(fileInfo.extsn)"><span>{{fileInfo.extsn}}</span></div>{{fileInfo.orginlNm}}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="board-view-con" v-html="qstnDetailInfo.qstn"></div>
                    <div class="board-view-bt-box">
                        <div class="board-view-bt">
                            <div class="entry-title"><div class="img-com __icon02"><span>답변 아이콘</span></div>답변</div>
                            <div class="entry-con" v-html="qstnDetailInfo.answer"></div>
                        </div>
                    </div>
                </div>
                <div class="btn-wrap __right mgt30 mgb20">
                    <button class="middle _bt-ypurple" @click="moveList()"><span>목록으로</span></button>
                    <button class="btn-w75 middle _bt-gray" @click="delQstnInfo(qstnDetailInfo.sn)"><span>삭제</span></button>
                </div>
            </template>
            <!-- //상세보기 -->
            <!-- 글쓰기 -->
            <div v-show="qstnSe == 'write'">
                <div class="board-write">
                    <table class="tb-none">
                        <colgroup>
                            <col style="width:20%;" />
                            <col style="width:*;" />
                        </colgroup>
                        <tbody>
                        <tr>
                            <th>제목</th>
                            <td>
                                <select name="" id="" style="width:25% !important;" v-model="newQstnInfo.clCd">
                                    <option v-for="cdInfo in clCdList"
                                            :key="'qstn' + cdInfo.cd"
                                            :value="cdInfo.cd" >{{cdInfo.cdNm}}</option>
                                </select>
                                <input type="text" class="mgl5" style="width:423px !important;" v-model="newQstnInfo.sj" ref="sj"/>
                            </td>
                        </tr>
                        <tr>
                            <th>내용</th>
                            <td>
                                <editor ref="qstnEditor"
                                        :editorid="1"
                                        :cn="newQstnInfo.cn"
                                        :setstorge="'qstn/' + mberInfo.mberNo + '/cn/' + dayInfo.ymd + '/'"
                                        :setbasepath="setBasePath"
                                        :cnimgtagfunc="setCnImgTag">
                                </editor>
                            </td>
                        </tr>
                        <tr>
                            <th>첨부파일</th>
                            <td>
                                <fileupload ref="fileList"
                                            :formse="'dragAndBtn'"
                                            :filelist="fileList"
                                            :maxcnt="5"
                                            :maxsize="10"
                                            :extsns="'gif,jpg,doc,xls,ppt,pdf,txt,xlsx,png,pptx,docx,jpeg,zip,hwp,bmp'"
                                            :setstorge="'qstn/' + mberInfo.mberNo + '/attach/' + dayInfo.ymd + '/'">
                                </fileupload>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="btn-wrap __center mgt30 mgb20">
                    <button class="btn-w75 middle _bt-blue" @click="saveQstnInfo()"><span>저장</span></button>
                    <button class="btn-w75 middle _bt-gray" @click="moveList()"><span>취소</span></button>
                </div>
            </div>
            <!-- //글쓰기 -->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'qstn_popup',
        props:['params'],
        data: function(){
            return {
                paginginfo: {
                    totCnt: 0, /* 총게시물 수*/
                    pageListCnt: 8, /* 한 페이지당 게시물수 */
                    pageCnt: 10, /* 페이지수 */
                    curPageNum: 1,/* 현재페이지 */
                    callBackFuc:null
                },
                url : '',
                qstnSe : 'list',
                fileList : new Array(),
                clCdList : new Array(),
                qstnList : new Array(),
                qstnDetailInfo : new Array(),
                qstnFileList : new Array(),
                newQstnInfo : {
                    clCd : '',
                    sj : '',
                    cn : ''
                },
                setBasePath:'/upload/'
            }
        },
        methods: {
            selectQstnList : function(){//일대일문의 리스트 조회
                const _this = this;
                this.axios.post(this.url + '/cs/qstn/searchQstnList.act',{
                    pagingInfo : {
                        curPageNum : _this.paginginfo.curPageNum,
                        startCnt : ((_this.paginginfo.curPageNum-1) * _this.paginginfo.pageListCnt)+1,
                        endCnt : _this.paginginfo.curPageNum * _this.paginginfo.pageListCnt,
                        fcltcd : _this.mberInfo.fcltcd,
                        mberNo : _this.mberInfo.mberNo,
                    }
                }).then(function(response) {
                    _this.qstnList = response.data.qstnInfo.qstnList;
                    _this.paginginfo.totCnt = response.data.qstnInfo.pagingInfo.totCnt;
                    _this.paginginfo.curPageNum = response.data.qstnInfo.pagingInfo.curPageNum;
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            startRmtAstnc : function(){
                var url = "http://113366.com/onandon";
                var name = "bo6inRemote";

                window.open(url, name);
            },
            clickRmtAstnc : function(){//원격지원이 뭔가요? 팝업
                const popupInfo = {
                    se:'modal',
                    id:'explnRmtAstncPopup',
                    wid:'448',
                    hei:'',
                    url:'/works/cs/qstn/explnRmtAstncPopup.on',
                    tit:'원격지원 안내',
                    draggableAt:true,
                    param:null
                };

                this.$store.getters.getComponents.popup.create(popupInfo);


            },
            setCnImgTag:function(fileInfo,id){
                var imgUrl =
                    "http://agency.gulumma.net/file/onHwpImgdownload.do?STORGE="+fileInfo.storge+"&FILENM="+fileInfo.fileNm;
                if(location.href.indexOf("localhost") > -1||location.href.indexOf("192.168.10") > -1||location.href.indexOf("192.168.26") > -1){
                    imgUrl =
                        this.$onbiLib.getImageFileUrl(fileInfo.fileSe,fileInfo.fileNm,fileInfo.storge,fileInfo.extsn,this.setBasePath);
                }

                var imgTag = "<img src='" + imgUrl + "' ";

                var contentWid = document.getElementById(id).offsetWidth - 30;
                if(fileInfo.imgWid > contentWid){
                    imgTag += "style='width:" + contentWid + "px;'";
                }
                imgTag += "/>";

                return imgTag;
            },
            validCheck : function() {//일대일 문의 새로 작성 저장
                if(this.newQstnInfo.sj.trim() ==""){
                    this.$toasted.show("제목을 작성해주십시오.");
                    this.$refs.sj.focus();
                    return true;
                }

                if(this.newQstnInfo.cn.trim() == "<p><br></p>"){
                    this.$toasted.show("내용을 작성해주십시오.");
                    return true;
                }

                return false;
            },
            saveQstnInfo : function(){//일대일 문의 새로 작성 저장
                const _this = this;
                this.newQstnInfo.cn = window.Editor.getContent();

                if(this.validCheck()){
                    return false;
                }

                this.axios.post(this.url + '/cs/qstn/saveQstnInfo.act',{
                    fcltcd : this.mberInfo.fcltcd,
                    mberNo : this.mberInfo.mberNo,
                    qstnInfo : this.newQstnInfo,
                    fileList : this.fileList
                }).then(function(response) {
                    if(response.data.insertProc == 'Y'){
                        _this.$toasted.show(_this.$onbiLib.msg.suc.save,{duration:1000,type:"success"});
                        _this.paginginfo.curPageNum = 1;
                        _this.moveList();
                    }
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            delQstnInfo : function(sn){//일대일문의 삭제
                const _this = this;

                if(!confirm("삭제하시겠습니까?")){
                    return;
                }

                this.axios.post(this.url + '/cs/qstn/deleteQstnInfo.act',{
                    fcltcd : this.mberInfo.fcltcd,
                    mberNo : this.mberInfo.mberNo,
                    sn : sn
                }).then(function(response) {
                    if(response.data.deleteProc == 'Y'){
                        _this.$toasted.show(_this.$onbiLib.msg.suc.del,{duration:1000,type:"success"});
                        _this.moveList();
                    }
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });

            },
            detailQstnInfo : function(sn){//일대일 문의 상세보기
                const _this = this;
                this.axios.post(this.url + '/cs/qstn/searchQstnDetailInfo.act',{
                    fcltcd : this.mberInfo.fcltcd,
                    mberNo : this.mberInfo.mberNo,
                    sn : sn
                }).then(function(response) {
                    _this.qstnDetailInfo = response.data.qstnInfo.qstnDetailInfo;
                    _this.qstnFileList = response.data.qstnInfo.qstnFileList;
                    _this.qstnSe = 'view';
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            moveList : function(){//목록으로 이동
                this.qstnSe = 'list';
                this.selectQstnList();
                this.initQstnInfo();
            },
            initQstnInfo : function(){
                window.Editor.modify({content:" ", attachments:[]});
                this.fileList = [];

                this.newQstnInfo = {
                    clCd : '',
                    sj : '',
                    cn : ''
                };
                this.newQstnInfo.clCd = this.clCdList[0].cd;
            },
            getFileClass : function(extsn){
                return 'img-com __icon-' + extsn.toLowerCase();
            },
            downloadFile : function(fileInfo){
                const url = this.url + '/cs/qstn/qstnFileDownLoad.act';
                const params = 'sn='+this.qstnDetailInfo.sn+'&fgrpCd='+fileInfo.fgrpCd+'&fileCd='+fileInfo.fileCd;
                this.$store.getters.getComponents.app.setFileDownLoadUrl(url,params);
            }
        },
        computed: {
            mberInfo: function(){
                return this.$store.getters.getMberInfo;
            },
            dayInfo: function(){
                return this.$store.getters.getDayInfo;
            }
        },
        mounted : function(){
            const _this = this;
            const url = document.location.href;

            this.paginginfo.callBackFunc = this.selectQstnList;

            if(url.indexOf('/works') > -1){
                this.url = '/works';
            }else{
                this.url = '/cloud';
            }

            var searchInfo = {cdGrp : 'CNS'};
            this.$onbiLib.searchCmmnCodeList(searchInfo).then(function(codeInfo){
                _this.clCdList = codeInfo;
                _this.newQstnInfo.clCd = _this.clCdList[0].cd;
            });

            var qstnSe = this.params.qstnSe;

            if(qstnSe == 'dtl'){
                var sn = this.params.sn;
                this.detailQstnInfo(sn);
            }else{
                this.selectQstnList();
                this.qstnSe = qstnSe;
            }
        }
    }
</script>

<style scoped>

</style>